export const FormTypes = {
    edit: 'edit',
    new: 'new'
};
